import React, { useEffect, useState } from 'react';
import { Aviso } from '../egora';
import './casca.css';

/**
 * Faixa fixa no topo quando o aparelho perde a rede.
 * `navigator.onLine` só sabe se há rede no aparelho; não sabe se o servidor
 * está fora. Servidor fora aparece como erro na tela afetada (AvisoDeFalha).
 */
export default function EstadoDeConexao() {
  const [semRede, setSemRede] = useState(
    () => typeof navigator !== 'undefined' && navigator.onLine === false
  );

  useEffect(() => {
    const voltou = () => setSemRede(false);
    const caiu = () => setSemRede(true);
    window.addEventListener('online', voltou);
    window.addEventListener('offline', caiu);
    return () => {
      window.removeEventListener('online', voltou);
      window.removeEventListener('offline', caiu);
    };
  }, []);

  if (!semRede) return null;

  return (
    <div className="casca-conexao">
      <Aviso tom="atencao" titulo="Sem conexão com a internet">
        Não dá para carregar nem salvar dados agora. Confira o Wi-Fi ou os dados do celular.
      </Aviso>
    </div>
  );
}
